import { Pipe, PipeTransform } from '@angular/core';
import { WhatsappTemplateCategory } from '../enums/whatsapp-template-category';
import { prettifyTemplateCategory } from '../helpers/prettify-template-category';

@Pipe({name: 'prettifyTemplateCategory'})
export class PrettifyTemplateCategoryPipe implements PipeTransform {
  transform(value: WhatsappTemplateCategory): string {
    return prettifyTemplateCategory(value);
  }
}